// export const DsfPlatformFixedMenu from "./fixedMenu.vue";
export const DsfPlatformFixedMenu = dsf.defineAsyncComponent("DsfPlatformFixedMenu", () => import(/*webpackChunkName:"platform_pc_homepage"*/ "./fixedMenu.vue"));
